export default __webpack_public_path__ + "static/media/logout.6425a4a2.svg";